import { useChapterStore } from '../../../shared/store/useChapterStore';
import Button from '@/components/Button';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMissionRouteParams } from '@/pages/mission/shared/hooks/useMissionRouteParams';

export const Assessment = () => {
  const chapterPage = useChapterStore((state) => state.chapterPage);
  const status = useChapterStore((state) => state.status);
  const { missionSlug, chapterTitleEncoded } = useMissionRouteParams();
  const navigate = useNavigate();

  const { title, description, button } = useMemo(() => {
    const assessmentArea = chapterPage?.assessmentArea;
    const fields = {
      PRE_ASSESSMENT: {
        title: assessmentArea?.beforeTitle,
        description: assessmentArea?.beforeDescription,
        button: assessmentArea?.beforeButton,
      },
      POST_ASSESSMENT: {
        title: assessmentArea?.afterTitle,
        description: assessmentArea?.afterDescription,
        button: assessmentArea?.afterButton,
      },
    };
    return { status, ...fields[status || 'PRE_ASSESSMENT'] };
  }, [status, chapterPage]);

  if (!chapterPage) return null;

  const onPressAssessment = () => {
    navigate(`/mission/${missionSlug}/chapter/${chapterTitleEncoded}/assessment`);
  };

  return (
    <div className="my-6 rounded-2xl border border-[#9FC3FA] bg-[#F6F9FF] p-5">
      <div className="mb-sh-15 flex items-center gap-sh-15 ">
        <img
          src={chapterPage?.assessmentArea?.assessmentIcon?.url}
          alt="Assessment Icon"
          className="h-[38px] w-[38px]"
        />
        <h3 className="!mb-0 font-cadiz text-sh-28-32 font-bold">{title}</h3>
      </div>
      <p className="mb-sh-15 text-base text-gray-600">{description}</p>
      <Button theme="solid-primary-600" onClick={onPressAssessment}>
        {button}
      </Button>
    </div>
  );
};
